
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import capitalize from "lodash-es/capitalize";

  import UIButton from '@/components/button/ui-button.vue';
  import FormGroup from "@/components/form/FormGroup.vue";
  import FormGroupError from "@/components/form/FormGroupError.vue";
  import CardBodyButton from "@/components/card/CardBodyButton.vue";
  import PrefixedFormInput from "@/components/form/PrefixedFormInput.vue";

  @Component({
    components: {
      PrefixedFormInput,
      CardBodyButton,
      FormGroupError,
      UIButton,
      FormGroup,
    },
  })
  export default class CardForm extends Vue {
    @Prop({ type: Number, default: undefined }) readonly value?: number;
    @Prop({ type: String, default: undefined }) readonly shownValue?: string;
    @Prop({ type: String, required: true }) readonly subject!: string;
    @Prop({ type: String, default: undefined }) readonly buttonText?: string;
    @Prop({ type: String, default: undefined }) readonly subjectAddition?: string;
    @Prop({ type: String, default: undefined }) readonly description?: string;
    @Prop({ type: String, default: undefined }) readonly subjectClasses?: string;
    @Prop({ type: String, default: undefined }) readonly inputPrefix?: string;

    amount: number = 0;
    defaultPlaceholder: string = "XX";

    get labelClasses(): Record<string, boolean> {
      return {
        ["min-w-28"]: !this.subjectClasses,
        [this.subjectClasses!]: Boolean(this.subjectClasses),
      };
    }

    get shownAmount(): string {
      if (typeof this.value === "number" && this.value >= 0) {
        if (this.shownValue) {
          return this.shownValue;
        }

        return String(this.value);
      }

      return this.defaultPlaceholder;
    }

    @Watch("value", { immediate: true })
    watchHours(value: number) {
      this.amount = value;
    }

    get buttonDisabled(): boolean {
      return this.value === this.amount;
    }

    get buttonContent(): string {
      const text = this.buttonText ? this.buttonText : this.capitalizedSubject;
      return `Update ${text}`;
    }

    get capitalizedSubject(): string {
      return capitalize(this.subject);
    }

    updateHours(): void {
      if (this.buttonDisabled) {
        return;
      }
      this.$emit("update", this.amount);
    }
  }
